import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import { useDialog } from "../../../contexts/DialogContext";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import CustomFileField from "../../../components/CustomFileField";
import useKycDocument from "../../../hooks/useKycDocument";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const validationSchema = Yup.object().shape({
  file: Yup.mixed()
    .required("A file is required")
    .test("fileFormat", "Only support pdf and image file", (value) => {
      console.log(value, "ffffffffffff");
      return (
        value &&
        ["application/pdf", "image/jpeg", "image/jpg", "image/png", "image/webp"].includes(
          value.type,
        )
      );
    })
    .test("fileSize", "File size must be less than 100MB", (value) => {
      return value && value.size <= 100 * 1024 * 1024;
    }),
  documentType: Yup.string().required("Required"),
});

const Alert = styled(MuiAlert)(spacing);

const UploadKycDocument = (props) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [payload, setPayload] = useState(currentPayload);
  const { radUserId, refreshPage, id, kycDocument, dropDownValues, documentTitle } = props;

  console.log(dropDownValues, "dropDownValues");
  const { addKycDocument, kycDocuments, getKycDocument, uploadFile, isSubmitting } =
    useKycDocument();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog } = useDialog();

  const onSubmit = async (data, props) => {
    try {
      console.log(data, "datadata");
      console.log(data.file);
      console.log(data);
      let formData = new FormData();
      formData.append("file", data.file);
      formData.append("radUserId", radUserId);
      formData.append("title", documentTitle);
      formData.append("documentType", data.documentType);

      await uploadFile(formData);
      dispatch(showSuccessSnackbar("KYC document uploaded successfully!"));
      unSetDialog("upload_id_proof");
      refreshPage();
    } catch (ex) {
      const errorMsg = ex?.response?.data?.message || ex?.message || "Failed to upload document.";
      dispatch(showErrorSnackbar(errorMsg));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <ReactHookFormSelect
                name="documentType"
                label="DocumentType"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
              >
                {dropDownValues.map((dropDownValue) => {
                  return (
                    <MenuItem key={dropDownValue.key} value={dropDownValue.key}>
                      {dropDownValue.value}
                    </MenuItem>
                  );
                })}
              </ReactHookFormSelect>
            </Grid>

            <Grid item md={6}>
              <CustomFileField
                label="Upload"
                name="file"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
                accept="application/pdf,image/*"
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<UploadFileIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
              disabled={isSubmitting}
            >
              Upload
            </Button>

            <Button variant="text" onClick={() => unSetDialog("upload_id_proof")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default UploadKycDocument;
